module.exports = __webpack_public_path__ + "static/media/Esperanza.c38e0328.webp";